import { useEffect, useState } from "react";
import { getLandingAssets } from "../lib/landingAssets";

/**
 * Hook to fetch the public Landing Page Assets once and share them.
 * Returns `null` while loading, then the `sections` object.
 */
export default function useLandingAssets() {
  const [sections, setSections] = useState(null);

  useEffect(() => {
    let mounted = true;
    getLandingAssets().then((s) => {
      if (mounted) setSections(s);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return sections;
}
